import { WithNAFallback } from '@toggle/design-system';
import { getPriceStatus } from '@toggle/helpers';
import React from 'react';

import { priceChangeColors } from '~/utils/common/utils';

import {
  formatNumberWithUnit,
  formatPercentageNumber,
} from '../../utils/utils';
import styles from './NumberCell.module.scss';

interface NumberCellProps {
  value: number | undefined;
  percentage?: boolean;
  useFallbackDash?: boolean;
  fallbackTooltip?: string;
  includePercentSign?: boolean;
}

export const NumberCell = ({
  value,
  percentage,
  useFallbackDash,
  fallbackTooltip,
  includePercentSign = true,
}: NumberCellProps) => {
  const formattedValue = percentage
    ? formatPercentageNumber({ value, includePercentSign, addPlus: percentage })
    : formatNumberWithUnit(value);

  return (
    <span
      className={styles.numberTableValue}
      style={{ color: priceChangeColors[getPriceStatus(value)] }}
    >
      <WithNAFallback
        containerPadding="0 0 0 8px"
        check={formattedValue !== '-'}
        value={formattedValue}
        useFallbackDash={useFallbackDash}
        tooltip={fallbackTooltip}
      />
    </span>
  );
};
